var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3010_14115)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0616 12.2074C13.0616 14.8013 10.9797 16.9042 8.41156 16.9042C5.8434 16.9042 3.76172 14.8019 3.76172 12.2074C3.76172 9.61283 5.84356 7.51074 8.41156 7.51074C10.9796 7.51074 13.0616 9.61347 13.0616 12.2074ZM18.1627 12.2074C18.1627 14.6492 17.1217 16.6286 15.8377 16.6286C14.5537 16.6286 13.5127 14.6486 13.5127 12.2074C13.5127 9.76616 14.5537 7.7862 15.8377 7.7862C17.1217 7.7862 18.1627 9.76616 18.1627 12.2074ZM20.2491 12.2074C20.2491 14.3952 19.8829 16.1686 19.4314 16.1686C18.9798 16.1686 18.6136 14.3945 18.6136 12.2074C18.6136 10.0202 18.9798 8.24618 19.4315 8.24618C19.8832 8.24618 20.2491 10.0198 20.2491 12.2074Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3010_14115"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.409792cbbd2e516f1698742d13e09ec9.svg";
export { ForwardRef as ReactComponent };